/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { AppSchemasArbitratorCriterionInput } from './appSchemasArbitratorCriterionInput';

export interface UpdateCriteriaRequest {
  /**
     * @minItems 1
     * @maxItems 20
     */
  criteria: AppSchemasArbitratorCriterionInput[];
}
